import { client, authHeaders } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetSceneProductsParams = paths['/api/v1/scene_products']['get']['parameters']['query'];
export type GetSceneProductsResponse =
  paths['/api/v1/scene_products']['get']['responses'][200]['content']['application/json']['sceneProducts'];

export async function getSceneProducts(params: GetSceneProductsParams): Promise<GetSceneProductsResponse> {
  const { data, error } = await client.GET('/api/v1/scene_products', {
    headers: authHeaders(),
    params: {
      query: {
        ...params
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting scene products');
  return data.sceneProducts;
}
